import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useDevelopmentalRubric from '../../../../../hooks/developmental-rubrics/useDevelopmentalRubrics'
import Module from '../../../../layout/Module'
import { useNavigate } from 'react-router-dom'
import DataGrid from '../../../../table/DataGrid'
import IconTooltipButton from '../../../../button/IconTooltipButton'
import {
  updateDevelopmentalRubricDialog,
  updateDevelopmentalRubricPreview
} from '../../../../../store/actions/developmental-rubrics.actions'
import { useParams } from 'react-router-dom'
import TextLog from '../../../../text/TextLog'
import TextNote from '../../../../text/TextNote'
import { Chip, Menu, Tooltip } from '@mui/material'
import ListMenu from '../../../../commom/ListMenu'
import { updateColumnTableCurriculum } from '../../../../../store/actions/datatable.actions'
import FilterButtonDevelopmentalRubric from '../Filter/Filter'
import TextFormatDateRange from '../../../../text/TextFormatDateRange'
import { getObjectCurriculumElementsDR } from '../../utils'
import useSubjects from '../../../../../hooks/subjects/useSubjects'
import ChildCard from '../../../../card/ChildCard'

const List = () => {
  const navigate = useNavigate()
  const { curriculumId } = useParams()
  const dispatch = useDispatch()
  const permissions = useSelector((state) => state?.session?.permissions?.dr || {})
  const years = useSelector((state) => state?.tenant?.years || [])
  const subjects = useSelector((state) => state?.subject?.list || [])

  const { isLoading: isLoadingSubject } = useSubjects()
  const { isLoading, isLoadingList, getDevelopmentalRubrics } = useDevelopmentalRubric()

  const list = useSelector((state) => (state?.dr ? state?.dr[curriculumId]?.list || [] : []))
  const totalList = useSelector((state) => (state?.dr ? state?.dr[curriculumId]?.totalList || 0 : 0))

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const state = useSelector((state) => state?.filter?.dr)
  const skip = useSelector((state) => state?.datatable?.dr?.skip || 0)
  const rowsPerPage = useSelector((state) => state?.datatable?.dr?.rowsPerPage || 50)
  const columnsTable = useSelector((state) => state?.datatable?.dr?.[curriculumId] || [])

  const [menuEdit, setMenuEdit] = useState({ mouseX: null, mouseY: null })
  const [dataMenu, setDataMenu] = useState(null)

  useEffect(() => {
    getDevelopmentalRubrics(curriculumId, skip, rowsPerPage, state?.filter)
  }, [curriculumId, rowsPerPage, skip, state, state?.filter])

  useEffect(() => {
    const columns = [
      {
        label: 'Name',
        key: 'name',
        align: 'left',
        width: 500,
        show: true,
        hide: true,
        position: 1,
        sort: true
      },
      {
        label: 'Year level',
        key: 'yearLevel',
        align: 'left',
        width: 250,
        show: true,
        hide: true,
        position: 2,
        sort: true
      },
      { label: 'Period', key: 'period', align: 'center', width: 200, show: true, hide: true, position: 7 },
      {
        label: '# Elements',
        key: 'lenGS',
        align: 'center',
        className: 'text-center',
        show: true,
        width: 80,
        hide: true,
        position: 8
      },
      {
        label: '# Worked examples',
        key: 'lenWE',
        align: 'center',
        className: 'text-center',
        show: true,
        width: 80,
        hide: true,
        position: 9
      },
      {
        label: '# Growth goals',
        key: 'lenGG',
        align: 'center',
        className: 'text-center',
        show: true,
        width: 80,
        hide: true,
        position: 10
      }
    ]

    if (currentCurriculum) {
      const elements = {}
      if (currentCurriculum.elementsStructure) {
        elements[currentCurriculum.elementsStructure?._id] = {
          label: currentCurriculum.elementsStructure?.name,
          key: 'elementId',
          show: true,
          caret: true,
          hide: true,
          position: 3,
          width: 100,
          className: 'text-nowrap',
          sort: true
        }

        const subElement = currentCurriculum.elementsStructure?.children[0]
        if (subElement) {
          elements[subElement?._id] = {
            label: subElement?.name,
            key: 'subElementId',
            show: true,
            caret: true,
            hide: true,
            position: 4,
            width: 100,
            className: 'text-nowrap',
            sort: true
          }
        }
      }

      Object.keys(elements).forEach((key) => {
        columns.push(elements[key])
      })
    }

    // if (subjects.length > 0) {
    //   columns.push({
    //     label: 'Status',
    //     key: 'status',
    //     align: 'left',
    //     show: true,
    //     hide: true,
    //     position: 6,
    //     sort: true
    //   })
    // }
    if (subjects.length > 0) {
      columns.push({
        label: 'Subject',
        key: 'subjectId',
        align: 'left',
        width: 250,
        show: true,
        hide: true,
        position: 5,
        sort: true
      })
    }

    columns.sort((a, b) => a.position - b.position)
    dispatch(updateColumnTableCurriculum(currentCurriculum._id, 'dr', columns, true))
  }, [subjects, currentCurriculum])

  const onRedirect = (id, step) => {
    navigate(`/dashboard/developmental-rubrics/${curriculumId}/edit/${id}/step/${step}`)
  }
  const handleMenuClose = () => setMenuEdit({ mouseX: null, mouseY: null })
  const handleMenuOpen = (event, data) => {
    setMenuEdit({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    })
    setDataMenu(data)
  }

  return (
    <>
      <Module.BodyHeader className='border-b border-b-2 border-primary justify-start'>
        <ChildCard />
        <FilterButtonDevelopmentalRubric />
      </Module.BodyHeader>
      <Module.BodyContainer>
        <DataGrid
          id='developmental-rubrics'
          nameModule='dr'
          curriculumId={curriculumId}
          rows={list.map((row, index) => {
            const subject = subjects.find((item) => item._id === row.subjectId)
            const elements = getObjectCurriculumElementsDR(
              currentCurriculum?.elements,
              currentCurriculum?.elementsStructure,
              row?.curriculumElements || {}
            )
            const yearLevel = row.yearLevel?.map((item) => years.find((year) => year._id === item)?.name)
            const textLinkedClasses = row?.linkedClasses?.length > 0 ? 'unlink' : 'link'
            return {
              ...row,
              index: index + 1 + rowsPerPage * skip,
              note: <TextNote notes={row.notes || ''} />,
              log: <TextLog updatedAt={row.updatedAt} updatedBy={row.updatedBy} />,
              elementId: elements?.element?.valueName || '',
              subElementId: elements?.subElement?.valueName || '',
              lenGS: permissions?.preview ? (
                <div>
                  {row?.lcs?.length > 0 ? (
                    <Tooltip title='Preview granular steps' arrow>
                      <Chip
                        id={`preview-${row._id}`}
                        disabled={isLoading}
                        icon='expand-alt'
                        size='small'
                        label={row?.lcs?.length}
                        onClick={() => dispatch(updateDevelopmentalRubricPreview(row._id))}
                      />
                    </Tooltip>
                  ) : (
                    0
                  )}
                </div>
              ) : (
                row?.lcs?.length || 0
              ),
              lenGG: permissions?.preview ? (
                <div>
                  {row?.growthGoals?.length > 0 ? (
                    <Tooltip title='Preview growth goals' arrow>
                      <Chip
                        id={`preview-${row._id}`}
                        disabled={isLoading}
                        icon='expand-alt'
                        size='small'
                        label={row?.growthGoals?.length}
                        onClick={() => dispatch(updateDevelopmentalRubricPreview(row._id, 'growthGoals'))}
                      />
                    </Tooltip>
                  ) : (
                    0
                  )}
                </div>
              ) : (
                row?.growthGoals?.length || 0
              ),
              lenWE: permissions?.preview ? (
                <div>
                  {row?.workedExamples?.length > 0 ? (
                    <Tooltip title='Preview growth goals' arrow>
                      <Chip
                        id={`preview-${row._id}`}
                        disabled={isLoading}
                        icon='expand-alt'
                        size='small'
                        label={row?.workedExamples?.length}
                        onClick={() => dispatch(updateDevelopmentalRubricPreview(row._id, 'workedExamples'))}
                      />
                    </Tooltip>
                  ) : (
                    0
                  )}
                </div>
              ) : (
                row?.workedExamples?.length || 0
              ),
              subjectId: subject?.name || '',
              linked: (
                <div className='flex items-center gap-1 items-center justify-center'>
                  <IconTooltipButton
                    id={`unlink-link-${row._id}`}
                    disabled={isLoading}
                    title={row?.linkedClasses?.length > 0 ? 'Unlink' : 'Link'}
                    icon='link'
                    className={row?.linkedClasses?.length > 0 ? '' : 'opacity-75'}
                    style={{ color: row?.linkedClasses?.length > 0 ? 'var(--accent)' : 'var(--secondary)' }}
                    onClick={
                      permissions?.[`${textLinkedClasses}ed`]
                        ? () => dispatch(updateDevelopmentalRubricDialog(true, textLinkedClasses, row))
                        : undefined
                    }
                  />
                </div>
              ),
              period: (
                <TextFormatDateRange
                  colorText={row?.linkedClasses?.length > 0 ? 'text-accent' : 'text-primary opacity-50'}
                  className='text-sm text-nowrap'
                  startDate={row.startDate || ''}
                  endDate={row.endDate || ''}
                />
              ),
              yearLevel: yearLevel?.join(', ') || '',
              actions: (
                <div className='flex items-center gap-1 items-center justify-center'>
                  {permissions?.preview && (
                    <IconTooltipButton
                      id={`preview-${row._id}`}
                      disabled={isLoading}
                      title='Preview'
                      icon='expand-alt'
                      onClick={() => dispatch(updateDevelopmentalRubricPreview(row._id))}
                    />
                  )}
                  {permissions?.cloned && (
                    <IconTooltipButton
                      id={`clone-${row._id}`}
                      disabled={isLoading}
                      title='Clone'
                      icon='clone'
                      onClick={() => dispatch(updateDevelopmentalRubricDialog(true, 'clone', row))}
                    />
                  )}
                  {permissions?.updated && (
                    <IconTooltipButton
                      id={`edit-${row._id}`}
                      disabled={isLoading}
                      title='Edit'
                      icon='pen'
                      onClick={(e) => handleMenuOpen(e, row)}
                    />
                  )}
                  {permissions.archived && (
                    <IconTooltipButton
                      id={`archive-${row._id}`}
                      disabled={isLoading}
                      title='Archive'
                      icon='archive'
                      onClick={() => dispatch(updateDevelopmentalRubricDialog(true, 'archive', row))}
                    />
                  )}
                  {permissions.deleted && (
                    <IconTooltipButton
                      id={`delete-${row._id}`}
                      disabled={isLoading}
                      title='Delete'
                      icon='trash-alt'
                      onClick={() => dispatch(updateDevelopmentalRubricDialog(true, 'delete', row))}
                    />
                  )}
                </div>
              )
            }
          })}
          loading={isLoadingList || isLoadingSubject}
          totalRows={totalList}
          skip={skip}
          rowsPerPage={rowsPerPage}
          columns={[
            { label: '#', key: 'index', align: 'center', width: 10, show: true, hide: false },
            ...columnsTable,
            {
              label: 'Note',
              key: 'note',
              align: 'center',
              className: 'text-center',
              show: true,
              width: 50,
              hide: false
            },
            {
              label: 'Log',
              key: 'log',
              align: 'center',
              className: 'text-center',
              width: 120,
              show: true,
              hide: false
            },
            {
              label: 'Link / Unlink',
              key: 'linked',
              align: 'center',
              className: 'text-center',
              width: 120,
              show: true,
              hide: false
            },
            { label: 'Actions', key: 'actions', align: 'center', width: 50, show: true, hide: false }
          ]}
          labelNoRows="You don't have any developmental rubrics yet"
        />
      </Module.BodyContainer>
      {menuEdit && (
        <Menu
          id={`menuEdit-${curriculumId}`}
          MenuListProps={{
            style: { width: '260px' },
            className: 'list-menuEdit p-0'
          }}
          keepMounted
          open={menuEdit.mouseY !== null}
          onClose={handleMenuClose}
          anchorReference='anchorPosition'
          anchorPosition={
            menuEdit.mouseY !== null && menuEdit.mouseX !== null
              ? { top: menuEdit.mouseY, left: menuEdit.mouseX }
              : undefined
          }
        >
          <ListMenu
            id={`menuEdit-list-${curriculumId}`}
            items={[
              {
                label: 'Edit basic information',
                permissions: permissions?.updated?.includes('basic-information'),
                onClick: () => onRedirect(dataMenu._id, 'basic-information')
              },
              {
                label: 'Edit subject',
                permissions: permissions?.updated?.includes('subject'),
                onClick: () => onRedirect(dataMenu._id, 'subject')
              },
              {
                label: 'Add / remove learning continuum',
                permissions: permissions?.updated?.includes('lcs'),
                onClick: () => onRedirect(dataMenu._id, 'learning-continuum')
              },
              {
                label: 'Granular steps',
                permissions:
                  permissions?.updated?.includes('created-granular-step') ||
                  permissions?.updated?.includes('updated-granular-step') ||
                  permissions?.updated?.includes('deleted-granular-step'),
                onClick: () => onRedirect(dataMenu._id, 'granular-step')
              },
              {
                label: 'Worked examples',
                permissions: permissions?.updated?.includes('worked-examples'),
                onClick: () => onRedirect(dataMenu._id, 'worked-examples')
              },
              {
                label: 'Growth goals',
                permissions: permissions?.updated?.includes('growth-goals'),
                onClick: () => onRedirect(dataMenu._id, 'growth-goals')
              },
              {
                label: 'Edit notes',
                permissions: permissions?.updated?.includes('notes'),
                onClick: () => dispatch(updateDevelopmentalRubricDialog(true, 'edit notes', dataMenu))
              }
            ]
              .filter((item) => item.permissions)
              .map((item) => ({
                ...item,
                onClick: () => {
                  if (item.onClick) {
                    item.onClick()
                  }
                  handleMenuClose()
                }
              }))}
          />
        </Menu>
      )}
    </>
  )
}

export default List
